// The category catalog is global and seed-only, so it is cached by shape rather than by page:
// `categoryGroups` is the whole catalog (the product form picks from it) and `inUseCategoryGroups`
// is the club's own shelf (every filter lists that, so a club selling six things is not handed a
// hundred options).
export default {
  state: {
    categoryGroups: [],
    inUseCategoryGroups: [],
  },
  getters: {
    productCategories: (state) => state.categoryGroups
      .flatMap((group) => (group && group.categories) || []),
    inUseProductCategories: (state) => state.inUseCategoryGroups
      .flatMap((group) => (group && group.categories) || []),
  },
  mutations: {
    setProductCategoryGroups(state, payload) {
      state.categoryGroups = payload || [];
    },
    setInUseProductCategoryGroups(state, payload) {
      state.inUseCategoryGroups = payload || [];
    },
  },
};
